<template>
  <div>
    <el-card class="box-card" body-style="min-height:90vh;">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="基础信息" name="first">
          <shop-info></shop-info>
        </el-tab-pane>
        <el-tab-pane label="修改密码" name="second">
          <shop-pwd></shop-pwd>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import ShopInfo from './components/ShopInfo.vue'
import ShopPwd from './components/ShopPwd.vue'
export default {
  name: 'InfoConfig',
  components: {
    ShopInfo,
    ShopPwd
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      activeName: 'first',
      activeNum:1
    }
  },
  mounted () {
    var that = this;
  },
  methods: {
    /* 切换选项卡操作 */
    handleClick (tab) {
      if(tab.name === 'first'){
        this.activeNum = 1
      }else if(tab.name === 'second'){
        this.activeNum = 2
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/shop/InfoConfig.vue